const de = {
  copyRight: " ",
  home: "Heim",
  examination: "Keine bewegung! Identifizieren!",
  course: "Kurse",
  record: "Notiert",
  help: "Hilfe",
  register: "Eine Liste Ausfüllen",
  login: "Einloggen",
  login2: 'Angestellte.',
  usernamePasswordLogin: "Benutzername loggen",
  search: "Suche Läuft",
  reset: "Umplanen",
  username: "BenutzerName",
  technicalLiterature: "Fachliteratur",
  personalcollect: "Private besetzung",
  usernameOrEmail: "Entweder der benutzername Oder das e-mailkonto",
  password: "kennwort",
  oldPassword: "Der alte code",
  newPassword: "Neuer code",
  confirm: "Abschuss bestätigen",
  sure: "Abschuss bestätigen",
  cancel: "Korrekt",
  tips: "Tipp",
  save: "Intakt",
  submit: "Eingereicht werden",
  confirmSubmit: "Bestätigung der überweisung?",
  tenantCode: "TenantCode",
  email: "E-mail. Ja.",
  validationCode: "Authentifizierungscode erhalten.",
  inputValidationCode: "Authentifizierungscode eingeben",
  forgetPassword: "Du hast die kombination vergessen?",
  updatePasswords: 'Codes ändern.',
  dateOfBirth: 'Geburtsdatum',
  smsCodeLogin: "SMS codes, loggen.",
  phoneNumber: "Telefon nummern.",
  sendValidationCode: "Authentifizierungscode Senden",
  send: "Senden.",
  cutdown: "Schon lange vor der grenze",
  sendSuccess: "Abwurf erfolgreich.",
  registerSuccess: "Mit erfolg.",
  success: "Der erfolg",
  successAndExit: "Will jetzt selbsttätig schließen",
  failed: "Es war ein fehlschlag.",
  operation: "betrieb",
  return: "Abreise.",
  load: {
    loadMore: "Doppelte ladung.",
    loadFailed: "Geladen und nicht geladen!",
    noMoreData: "Keine daten mehr!",
    loading: "Laden...",
  },
  validate: {
    inputUsername: "Bitte geben sie einen benutzernamen ein",
    inputEmail: "Bitte geben sie ihren briefkasten ein.",
    inputPassword: "Code eingeben.",
    inputValidationCode: "Bitte geben sie die authentifizierungscodes ein",
    inputPhoneNumber: "Bitte geben sie ihre telefonnummer ein",
    usernameExists: "Benutzername existieren",
    inputPhoneLen: "Bitte geben sie eine in 11 minuten durchgesetzte telefonnummer ein",
    passwordMustFourLength: "Bitte geben sie ein passwort mit mindestens 4 ziffern länge ein",
    validationCodeMustFourLength: "Bitte geben sie ein authentifizierungscode mit mindestens 4 längen ein",
  },
  language: {
    zh: "中文",
    en: "English",
  },
  common: {
    link: "Link",
    tool: "Ausrüstung.",
    community: "Gemeinschaft.",
    gitee: "",
    github: "",
    admin: "(qohen) management.",
    changeLog: "Logbuch",
    feedback: "Feedback",
    legalNotices: "Ein rechtsgutachten.",
    legalNoticesContent:
      "Dieses projekt dient ausschließlich der praxis eines open-sourcop-projekts, ausschließlich zum lernen und ohne rechtliche probleme",
    privacyPolicy: "Unsere privateigentum ist privat.",
    privacyPolicyContent:
      "Unsere website wird die Von ihnen verwendeten informationen nicht streng nach den einschlägigen gesetzen und vorschriften und in der datenschutzpolitik erfassen und nutzen",
    developerCenter: "Zentrum für entwicklung."
  },
  header: {
    sourceCode: "Quellcode.",
    document: "Dokumente.",
    changeLog: "Logbuch",
    roadmap: "Die roadmap.",
    admin: "(qohen) management.",
    personal: 'Certificate',
    changePwd: "Das passwort ändern.",
    logout: "Annullieren.",
    certPrompt: 'Hier können Sie Ihr Zertifikat überprüfen.',
  },
  homePage: {
    startUsing: "Wenden sie an.",
    userCnt: "Oder benutzer.",
    examinationCnt: "Keine bewegung! Identifizieren!",
    subjectCnt: "Ein motto",
    courseCnt: "Kurse.",
    popularCourses: "Beliebte kurse",
    loadFailed: "Geladen und nicht geladen!",
    loadCoursesFailed: "Lade die hits für's ende!",
  },
  exam: {
    examinationName: "Name überprüfen.",
    examinationType: "Typen überprüfen.",
    examinationTime: "Zeit überprüfen.",
    status: "Versetzen.",
    score: "bruchzahlen",
    scoreDetail: "Einzelheiten.",
    scoreRank: "Ranking.",
    course: {
      courseName: "Name des kurses",
      courseIntroduction: "Einstieg in die klassen",
      chapter: "Kapitel",
      courseEvaluation: "Bericht.",
      inputEvaluation: "Geben sie den kommentar ein",
      studyExchange: "Eine studie",
      courseAttach: "Anhang.",
      registerStudents: "Registrierter student.",
      registerStudents1: "Registrierter student.",
      examination: "Keine bewegung! Identifizieren!",
      examinations: "Keine bewegung! Identifizieren!",
      courseFeatures: "Merkmale des kurses",
      learnHour: "Eine stunde lernen.",
      chapter1: "kapitel",
      memberCount: "Schüleranzahl: studium",
      evaluatesCount: "Beurteilung und berechnung.",
      youMayAlsoLike: "Ich dachte, das gefällt dir",
      hour: "Stunde.",
      charge: "Es ist",
      free: "Es kostet nichts.",
      atOnce: "Lernen.",
      registration: "Tragen sie es ein.",
      cancelRegistration: "Roger, streichen.",
      pleaseRegistration: "Tragen sie sich bitte ein.",
      startLearn: "Lernen.",
      submitSuccess: "Einspruch stattgegeben.",
      submitFailed: "Nach dem scheitern.",
      doNotResubmit: "Keine neuen anträge.",
      doReqexam: 'Bitte legen Sie die Prüfung zum Schulungskurs ab',
      defaultEvaluate: "Standard. - was",
      demoCourseName: "Schreiben",
      courses: {
        popularCourses: "Beliebte kurse",
        registerStudentsCnt: "Views.",
        level: "Der schwierigkeitsgrad.",
      }
    },
    records: {
      records: "Notiert."
    },
    exams: {
      examRemark: "Vorstellung.",
      examAttention: "(durchsage) achtung.",
      examTime: "Zeit für die prüfung",
      unLimitTime: "Es gibt keine grenzen.",
      all: "Mit allem.",
      latestRelease: "In die letzte ausgabe.",
      mostClicks: "Die meisten klicks.",
      parameters: "Parameter.",
      end: "Test bestanden.",
      notStarted: "Prüfung nicht",
      start: "Und action!",
      sureStart: "Willst du wirklich anfangen?",
      evaluation: "Bericht.",
      startFailed: "Starten scheitern",
      inputEvaluation: "Geben sie.",
      submitSuccess: "Vorzulegen erfolg",
      doNotResubmit: "Keine neuen anträge.",
      defaultEvaluate: "Standard. - was?",
      examResult: 'Prüfungsergebnis',
      ok: 'OK',
      examResultContent: 'Herzlichen Glückwunsch, Sie haben {value} Punkte erreicht und die Prüfung bestanden. Jetzt können Sie Ihr Zertifikat überprüfen.'
    },
    startExam: {
      last: "Von ganz früher.",
      next: "Die nächste bitte.",
      progress: "Fortschritt.",
      answerCard: "Ihre karte.",
      isFirst: "Es war schon das erste thema",
      isLast: "Das ist jetzt der letzte kurs",
      getSubjectFailed: "Ich habe das thema noch nicht gefunden.",
      confirmExit: "Aber dafür brauche ich sie.?",
      startExam: "Beginn der Prüfung",
      subject: "Thema auf",
      score: "Gesamtpunkte.",
      tscore: 'Gesamtpunkte'
    },
    incorrect: {
      userName: "benutzername",
      score: "Gesamtpunkte.",
      startTime: "Zeit zu starten.",
      endTime: "Die zeit ist um.",
      duration: "Aber es dauert an.",
      correctNumber: "Richtige summe.",
      inCorrectNumber: "Das war keine richtige zahl",
      subjectList: "Eine liste mit themen.",
      userAnswer: "Ihre antwort.",
      answer: "Antworte ihm.",
      analysis: "Analyse.",
      right: "Ganz genau.",
      wrong: "Und nicht korrekt.",
      loadSubjectFailed: "Wir konnten keinen finden.",
      operator: "Automatische beurteilung des systems",
    },
    subject: {
      subjectTypeChoices: "SingleChoice",
      subjectTypeMultiChoices: "MultiChoice",
      subjectTypeJudgement: "Verurteilen.",
      subjectTypeShortAnswer: "ShortAnswer",
      subjectTypeFillBlank: "FillBlank",
      fillBlankAnswerPlaceholder: "Zwischen den angegebenen leerräumen durch ein zeilenumleitungszeichen abtrennt",
    }
  },
  personal: {
    account: {
      identifier: "Konto.",
      name: "Name",
      gender: "Geschlecht: männlich.",
      born: "Geburtsdatum",
      phone: "Ach, ein anruf.",
      email: "E-mail. Ja.",
      avatar: "Avatar zu schreiben.",
      inputIdentifier: "Bitte geben sie die kontonummer ein",
      modifySuccess: "Erfolgreich modifiziert.",
      modifyFailed: "Änderungen scheitern.",
      avatarUploadSuccess: "Habe dein foto erfolgreich hochgeladen",
      avatarUploadFailed: "Einen kaputten kopf hochzuladen war ein fehler",
      avatarUploadFormat: "Porträts können nur im JPG/PNG -format installiert werden.",
      avatarUploadSize: "Schon 2MB für das foto.",
    },
    pwd: {
      oldPwd: "Der alte code.",
      newPwd: "Neuer code.",
      confirmPwd: "Neuer code bestätigt.",
      inputNewPwd: "Bitte geben sie ein neues passwort ein",
      inputOldPwd: "Bitte geben sie den alten code ein",
      pwdLenTips: "Die zugangskodes müssen mindestens sechs ziffern haben",
      inputPwdAgain: "Bitte geben Sie das Passwort erneut ein",
      pwdNotEqual: "Die falschen zahlen stimmen nicht!",
      modifySuccess: "Erfolgreich modifiziert.",
      modifyFailed: "Änderungen scheitern."
    }
  },
  status: {
    examination: "Keine bewegung! Identifizieren!",
    practice: "Übung.",
    questionnaire: "Einen fragebogen.",
    interview: "Das bewerbungsgespräch",
    complete: "Die statistik ist vollendet.",
    markComplete: "Korrektur.",
    todoMark: "Es muss korrigiert werden.",
    right: "Ganz genau.",
    wrong: "Und nicht korrekt.",
    men: "mann",
    women: "Weiblich"
  },
  media: {
    audio: {
      progress: "Fortschritt geschrieben:",
      limit: "Noch spielverbot.",
      playFailed: "Die automatische wiedergabe ist fehlgeschlagen.",
      play: "spielen",
      pause: "Pause.",
      muted: "Weich und warm.",
      notMuted: "spielen",
      transSpeed: "Schneller Vorlauf: x"
    },
    video: {
      playError: "Das video ist zur zeit nicht verfügbar. Bitte versuchen sie es später noch einmal",
    }
  },
  searchForm: {
    document: 'Dokumente',
    fileUnavailable: 'Für dieses Dokument ist kein Link verfügbar',
    q: "Bitte geben sie das schlüsselwort ein",
    course: "Kurse.",
    exam: "Keine bewegung! Identifizieren!",
    other: "Saldo wird geprüft",
    searchSuccess: "Suche erfolgreich.",
    searchFailed: "Versuche fehlgeschlagen.",
    searchResult: 'Find relevant results about',
    searchUnit: 'a', // 个
    searchHistory: 'Search history',
    allClear: 'Clear all',
    searchTips: "You haven't searched yet",
    searchTop: 'Top trending Searches'
  },
  becomeAPartner: {
    mainHeader: "Werden Sie ein Sigenergy-zertifizierter Installateur",
    subheading:
      "Schließen Sie sich uns an und werden Sie Mitglied einer Gemeinschaft, die Wert auf Transparenz, Qualität, Wachstum und gegenseitige Unterstützung legt."
  },
  becomeBPartner: {
    mainHeader: 'Become a Sigenergy Verified Distributor',
    subheading: 'Join us to become a member of a community that values transparency, quality, growth and mutual support.'
  },
  document: {
    documentType: "Art des dokuments",
    filterTag: "Sieb markieren",
    all: "Mit allem.",
    documentFile: "Datentabelle.",
    videoFile: "Ein bedienungsanleitung.",
    voiceFile: "Richtlinien für das schnelle einsetzen",
    otherDocuments: "Zertifikat.",
    brochure: "Hier sind ein paar broschüren.",
    flyer: "Das riesenrad",
    image: "Bilder.",
    video: "Na video.",
    download: "Laden",
    center: "Dokumentenzentrum.",
    emptyResult: "Keine angaben.",
    plsSelectDocLang: 'Bitte wählen Sie die Dokumentsprache'
  },
  section: {
    filterTag: "Produktkategorie.",
    trainingTag: 'Kategorie Training',
    catalogue: "Inhalt.",
    total: "Addiert.",
    chapters: "kapitel",
    title: "Schlagzeile:",
    score: "bruchzahlen.",
    points: "Punkte",
    viewsNumber: "Ansichten",
    people: "Volk",
    videoDuration: "Dauer ",
    minutes: "Protokoll",
    collect: "Sammeln",
    upvote: 'Upvote',
    startExamination: 'Start the examination',
    startDate: 'Start date',
    endDate: 'End date'
  },
  notification: {
    contentTitle: "Titel des Hinweisinhalts",
    first: "Heim",
    contentTitleDetail: "Einzelheiten zur Bekanntmachung",
    contentAbstract: "Inhalt",
    viewNum: "Ansichten",
    commentsNum: "Kommentare",
    releaseDate: "Erscheinungsdatum"
  },
  problem: {
    contentTitle: "Q&A-Inhaltstitel",
    first: "Heim",
    contentTitleDetail: "details.",
    contentAbstract: "Überblick.",
    viewNum: "Ansichten",
    commentsNum: "Kommentare",
    updateDate: "Aktualisierungsdatum",
    commentsTitle: "Inhalt der evaluierung",
    searchDefault: 'Q&A',
    commentContent: 'Kommentar hinzufügen',
    commentScore: 'Evaluation total',
    previouspage: 'vorhergehend',
    nextpage: 'nächster',
    commentUnit: 'times'
  },
  warranty: {
    contentTitle: "Die garantierte garantie.",
    first: "Heim",
    contentTitleDetail: "Details zu den Garantiebedingungen"
  },
  library: {
    quickLink: 'Schnelle Links',
    batchDownload: 'Schnelle Links',
    category: 'Kategorie',
    subCategory: 'Unterkategorien',
    documentLanguage: 'Dokumentsprache',
    downloadTip: 'Mausklick zum download',
    filename: 'Name der datei',
    maxLimit: 'Wählen Sie die Anzahl der Dateien, maximal nicht mehr als {value}.',
    documentSearchKey: 'Bitte geben Sie das Schlüsselwort für den Dokumenttitel ein',
    allCategories:'Alle Kategorien',
    currentCategory:'Suche in der aktuellen Kategorie: {value}',
    searchSuccess:'Suche abgeschlossen, Suchbegriffe:',
    searchFailed:'Suche fehlgeschlagen, bitte versuchen Sie es erneut.',
    downloading: 'Herunterladen...',
    cancelDownload: 'Abbrechen',
    downloadCompleted: 'Download erfolgreich abgeschlossen!',
    downloadFailed: 'Download fehlgeschlagen',
    downloadCancelled: 'Download abgebrochen'
  }
};
de.chooseFile = 'Dateien auswählen'
de.select = 'Bitte auswählen'
de.library.enquiry = {
  dialogTitle: 'Anfrage & Feedback',
  basicInfo: 'Grundinformationen',
  issueSection: 'Problem / Feedback',
  additionalInfo: 'Zusätzliche Informationen',
  privacy: 'Datenschutzerklärung',
  yourName: 'Ihr Name',
  yourCompany: 'Ihre Firma',
  yourRole: 'Ihre Rolle',
  emailAddress: 'E-Mail-Adresse',
  issueType: 'Problemtyp',
  detailedDescription: 'Detaillierte Beschreibung',
  upload: 'Bild-/Datei-Upload',
  uploadTip: 'Mehrere Dateien, Größe < {value}MB',
  uploadDesc: 'Fehlercode, Schnittstellen-Screenshot, Dokument usw.',
  privacyAgree: 'Ich stimme zu, dass die Plattform diese Informationen zur Nachverfolgung nutzt.',
  roleDistributor: 'Distributor',
  roleInstaller: 'Installateur',
  roleGuests: 'Gast',
  issueFeatureInquiry: 'Funktionsanfrage',
  issueBugReport: 'Fehlerbericht',
  issueImprovement: 'Verbesserungsvorschlag',
  issueOther: 'Sonstiges',
  btnSubmit: 'Senden',
  btnCancel: 'Abbrechen',
  msgSubmitSuccess: 'Erfolgreich gesendet',
  msgSubmitFailed: 'Senden fehlgeschlagen',
  ruleRequired: 'Pflichtfeld',
  ruleInvalidEmail: 'Ungültige E-Mail',
  ruleAgreeRequired: 'Bitte stimmen Sie der Datenschutzerklärung zu',
  ruleFileTooLarge: 'Dateigröße muss < {value}MB sein'
};
de.library.enquiry.uploadSuccess = 'Upload erfolgreich'
de.library.enquiry.uploadFailed = 'Upload fehlgeschlagen'
de.library.enquiry.detailedDescriptionPlaceholder = 'Beschreiben Sie Ihr Problem, Nutzungsszenario und die gewünschte Verbesserung'
export default de;



// WEBPACK FOOTER //
// ./src/locales/lang/de/de.js